module.exports = __webpack_public_path__ + "media/dogs/adult-dog-avatar-b2d45508.svg";